import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import PayEquity from "@/pages/PayEquity";
import Fractional from "@/pages/Fractional";
import WageStudies from "@/pages/WageStudies";
import Toolkits from "@/pages/Toolkits";
import ToolkitDetail from "@/pages/ToolkitDetail";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import { Loader2 } from "lucide-react";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();
  if (admin === null) return <div className="min-h-screen flex items-center justify-center bg-forest-950"><Loader2 className="h-8 w-8 animate-spin text-golden-500" /></div>;
  if (admin === false) {
    // Full-page bounce to login (avoids client-side routing issues in some browsers).
    if (typeof window !== "undefined") window.location.href = "/admin/login";
    return null;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollTop />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/pay-equity" element={<PublicLayout><PayEquity /></PublicLayout>} />
            <Route path="/fractional-hr" element={<PublicLayout><Fractional /></PublicLayout>} />
            <Route path="/wage-studies" element={<PublicLayout><WageStudies /></PublicLayout>} />
            <Route path="/toolkits" element={<PublicLayout><Toolkits /></PublicLayout>} />
            <Route path="/toolkits/:id" element={<PublicLayout><ToolkitDetail /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/resources" element={<PublicLayout><Blog /></PublicLayout>} />
            <Route path="/resources/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/payment/success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
